import {Button} from '@luminopia/react-toolbox/lib/button'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import {ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import * as React from 'react'
import {FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './DeleteForm.css'

export interface IDeleteRequestFormFields {
  id: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<IDeleteRequestFormFields, {}, {}> {
  theme?: ITheme
}

class DeleteForm extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {
    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Button
          className={classNames.button}
          icon='delete_forever'
          label='Reject Request'
          disabled={submitting}
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default DeleteForm

/**
 * Component factory for creating forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const deleteFormFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: SubmitHandler<IDeleteRequestFormFields, {}, {}>,
  },
) => {
  const initialValues: IDeleteRequestFormFields = {
    id: '',
  }

  const formDecorator = reduxForm<IDeleteRequestFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
  })

  return formDecorator(DeleteForm)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/deletes/DeleteForm.tsx